import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loader flex-column"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-6 fw-bold mt-5" }, "Loading...", -1)
const _hoisted_4 = {
  key: 1,
  class: "page-loader flex-column"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mt-5" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border text-primary",
    role: "status"
  }),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-6 fw-bold ms-5" }, "Loading...")
], -1)
const _hoisted_6 = {
  key: 2,
  class: "page-loader"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaderType === 'spinner-message')
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3
      ]))
    : (_ctx.loaderType === 'spinner-logo')
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("img", {
            alt: "Logo",
            class: "max-h-75px",
            src: _ctx.logo
          }, null, 8, ["src"]),
          _hoisted_5
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7
        ]))
}